import ChildPageHeader from '@/components/UI/ChildPageHeader'
import {
  TOOLKIT_GENERATE_LEARNING_OUTCOMES,
  TOOLKIT_GENERATE_QNA_UPLOAD_DOC,
  TOOLKIT_SETUP_CONTEXTUALISED_CHAT,
  TOOLKIT_SUMMARISE_DOCUMENTS,
} from '@/config'
import CreateQuizModalTeachersToolkit from '@/routes/TeachersToolkit/popups/createQuizModalTeachersToolkit'
import { Button } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useParams } from 'react-router-dom'
import KGroupsTree from '@/components/UI/KGroupsTree'

const SetUpChat = () => {
  const { t } = useTranslation('translation')
  const history = useHistory()
  const { id } = useParams<{ id: string | undefined }>()
  const title = id ? id : 'chat'

  // Local selected group id replaces global fallback
  const [selectedGroupId, setSelectedGroupId] = useState<string | null>(null)
  const [showCreateQuizModal, setShowCreateQuizModal] = useState(false)

  const generateTitle = () => {
    switch (title) {
      case 'chat':
        return t('Set up contextualized chat')
      case 'learning-outcomes':
        return t('Set Learning Outcomes')
      case 'generate-qa':
        return t('Generate Q&A')
      case 'summarise-doc':
        return t('Summarize documents')
      case 'quiz':
        return t('Build a Quiz')
    }
  }

  const proceedHandler = () => {
    switch (title) {
      case 'chat':
        history.push(
          `${TOOLKIT_SETUP_CONTEXTUALISED_CHAT}?group=${selectedGroupId}`,
        )
        break
      case 'learning-outcomes':
        history.push(
          `${TOOLKIT_GENERATE_LEARNING_OUTCOMES}?group=${selectedGroupId}`,
        )
        break
      case 'generate-qa':
        history.push(
          `${TOOLKIT_GENERATE_QNA_UPLOAD_DOC}?group=${selectedGroupId}`,
        )
        break
      case 'summarise-doc':
        history.push(`${TOOLKIT_SUMMARISE_DOCUMENTS}?group=${selectedGroupId}`)
        break
      case 'quiz':
        setShowCreateQuizModal(true)
        break
      default:
        break
    }
  }

  return (
    <section className="page-mid-wraper h-without-foter">
      <CreateQuizModalTeachersToolkit
        show={showCreateQuizModal}
        onHide={() => {
          setShowCreateQuizModal(false)
        }}
        selectedGroupId={selectedGroupId}
        createSmartQuiz={true}
      />
      <ChildPageHeader
        title={generateTitle()}
        subTitle={t(
          'Select an existing knowledge group or create a new one to upload your content.',
        )}
        slot={{
          action: (
            <Button
              variant="contained"
              size="medium"
              disabled={!selectedGroupId}
              onClick={() => proceedHandler()}
            >
              {title === 'quiz'
                ? t('Proceed to Create Quiz')
                : t('Proceed to Upload Content')}
            </Button>
          ),
        }}
      />
      <KGroupsTree
        actions={{ add: true }}
        onSelectGroup={(group: any) => setSelectedGroupId(group?._id || null)}
      />
    </section>
  )
}

export default SetUpChat
